import { Star } from "lucide-react";

export const StarRating = ({ value = 0, count, size = "h-4 w-4", interactive = false, onChange, testId = "star-rating" }) => {
  const rounded = Math.round(value);
  return (
    <div className="flex items-center gap-0.5" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((s) => {
        const cls = `${size} ${rounded >= s ? "fill-amber-400 text-amber-400" : "fill-stone-200 text-stone-200"}`;
        return interactive ? (
          <button key={s} type="button" data-testid={`${testId}-star-${s}`} onClick={() => onChange(s)}
                  className="cursor-pointer hover:scale-110 transition-transform">
            <Star className={cls} />
          </button>
        ) : (
          <Star key={s} className={cls} />
        );
      })}
      {count !== undefined && <span className="ml-1 text-xs text-stone-400 mono">({count})</span>}
    </div>
  );
};
